$(window).on('scroll', function () {
    $('body').setDataAttribute('position', (window.pageYOffset < 100) ? 'top' : 'body');
});

$('header, footer').find('a[href*="#"]').not('[href="#"]').on('click', function (e) {
    if (this.pathname === window.location.pathname) {
        var target = $(`.${$(this).attr('href').split("#")[1]}`);
        if (target.length) {
            $.scrollTo(target.offset().top - 100);
            return;
        }

        window.location.href = '/' + $(this).attr('href');
    }

    window.location.href = $(this).attr('href');
});
